import {
  BARANG_JADI_IN_OPTIONS,
  BARANG_JADI_OUT_OPTIONS,
} from 'interfaces/IBarangJadiRequest'

const barangJadiSourceOrDestinationLabels = [
  ...BARANG_JADI_IN_OPTIONS,
  ...BARANG_JADI_OUT_OPTIONS,
].reduce<Record<string, string>>((labels, { key, label }) => {
  labels[key.toLowerCase().replace(/_/g, ' ')] = label
  return labels
}, {})

export default function getSourceOrDestinationLabel(value?: string): string {
  if (!value) return '-'

  const v = String(value).trim()
  const key = v.toLowerCase().replace(/_/g, ' ').replace(/\s+/g, ' ').trim()

  const map: Record<string, string> = {
    // common variants normalized to lowercase keys
    rnd: 'RnD',
    'rnd masuk': 'RnD (Masuk)',
    'rnd keluar': 'RnD (Keluar)',
    rndin: 'RnD (Masuk)',
    rndout: 'RnD (Keluar)',
    adjustment: 'Adjustment',
    'adjustment (produksi)': 'Adjustment (Produksi)',
    'customer return': 'Pengembalian Pelanggan',
    'in no cost': 'Masuk (Tanpa Biaya)',
    'out no cost': 'Di Keluarkan Tanpa Biaya',
    'masuk tanpa biaya': 'Masuk (Tanpa Biaya)',
    'keluar tanpa biaya': 'Keluar (Tanpa Biaya)',
    'barang masuk tanpa biaya (wajib tulis notes dari siapa)':
      'Masuk (Tanpa Biaya)',
    'barang di keluarkan tanpa biaya (wajib tulis notes untuk siapa)':
      'Keluar (Tanpa Biaya)',
    'barang dikeluarkan dengan biaya (wajib tulis tujuan mana di notes)':
      'Keluar (Dengan Biaya)',
    'filling additional': 'Penambahan Filling',
    'filling - ganti kemasan': 'Filling (ganti kemasan)',
    'filling - rework': 'Filling (rework)',
    'gudang jadi': 'Gudang Jadi',
    'gudang setengah jadi': 'Gudang Setengah Jadi',
    'sample - in house': 'Sample (In house)',
    'labeling: minta tambahan': 'Labeling: Minta Tambahan',
    qc: 'QC',
    'stok qc': 'Stok QC',
    productionreturnpremix: 'Pengembalian Produksi (Premix)',
    productionreturnpackaging: 'Pengembalian Produksi (Packaging)',
    productionadditionalrequest: 'Produksi Request Tambahan',
    'production additional request': 'Produksi Request Tambahan',
    'produksi request tambahan': 'Produksi Request Tambahan',
    'produksi - additional request': 'Produksi - Additional Request',
    batchrework: 'Rework Batch',
    'stj tukar kemasan': 'STJ Tukar Kemasan',
    'pak mul': 'Pak Mul',
    'purchase return': 'Purchase Return',
    purchasereturn: 'Purchase Return',
    packing: 'Packing',
    production: 'Produksi',
    'adjustment: barang rusak': 'Adjustment: Barang Rusak',
    'gudang filling': 'Gudang Filling',
    ...barangJadiSourceOrDestinationLabels,
  }

  if (map[key]) return map[key]

  // fallback to raw value (preserve original casing)
  return v
}
